<script>
import Conditions from '@/components/Conditions.vue'

export default {
  name: 'ConditionsView',
  components: {
    Conditions
  }
};
</script>

<template>
  <div class="conditions-page">
    <conditions :showBtn="false" :showCloseBtn="false"/>
  </div>
</template>

<style lang="postcss" scoped>
.conditions-page {
  @media (min-width: 992px) {
    background-color: var(--color-blue-medium);
  }
  .terms{
    input{
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
    a{
      color: var(--color-green);
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
